import React from 'react';

import { Link } from 'react-router';

function renderActions(_, { row, can, remove }) {
	const lang = row.campaign_lang;
	return (
		<div className='banners-icons'>
			<Link
				className='banners-edit-icon'
				to={`/offer-location-rules/lang-rules/edit/${lang}`}
			/>
			{can('delete') && (
				<a
					className='remove-icon'
					onClick={() => {
						if (confirm(`Delete rule (lang:${lang})?`)) {
							remove(lang);
						}
					}}
				/>
			)}
		</div>
	);
}

export default [
	[
		{
			index: 'campaign_lang',
			header: {
				className: 'text-left',
				title: 'Campaign lang'
			},
			column: {
				className: 'text-left'
			}
		},
		{
			index: 'actions',
			header: {
				title: 'actions'
			},
			column: {
				render: renderActions
			}
		}
	]
];



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/offer-location-rules/lang-rules/list/table-initial-data.js